import * as create from "./create";
import * as edit from "./edit";
import * as detail from "./detail";

import * as api from "services/api";
import { getErrors } from "helpers/error";
import { Callback } from "Types/Callback";
import ISubscription, { SubscriptionStatus } from "Types/Subscription";
import IBankBillet from "Types/BankBillet";
import IInstallment from "Types/Installment";

export const GET_SUBSCRIPTIONS = "[SUBSCRIPTION] GET_SUBSCRIPTIONS";
export const GET_SUBSCRIPTIONS_SUCCESS =
	"[SUBSCRIPTION] GET_SUBSCRIPTIONS_SUCCESS";
export const GET_SUBSCRIPTIONS_FAILED =
	"[SUBSCRIPTION] GET_SUBSCRIPTIONS_FAILED";

export const GET_INSTALLMENTS = "[SUBSCRIPTION] GET_INSTALLMENTS";
export const GET_INSTALLMENTS_SUCCESS =
	"[SUBSCRIPTION] GET_INSTALLMENTS_SUCCESS";
export const GET_INSTALLMENTS_FAILED = "[SUBSCRIPTION] GET_INSTALLMENTS_FAILED";

export const PAY_INSTALLMENTS = "[SUBSCRIPTION] PAY_INSTALLMENTS";
export const PAY_INSTALLMENTS_SUCCESS =
	"[SUBSCRIPTION] PAY_INSTALLMENTS_SUCCESS";
export const PAY_INSTALLMENTS_FAILED = "[SUBSCRIPTION] PAY_INSTALLMENTS_FAILED";

export const IMPORT_SUBSCRIPTIONS = "[SUBSCRIPTION] IMPORT_SUBSCRIPTIONS";
export const IMPORT_SUBSCRIPTIONS_SUCCESS =
	"[SUBSCRIPTION] IMPORT_SUBSCRIPTIONS_SUCCESS";
export const IMPORT_SUBSCRIPTIONS_FAILED =
	"[SUBSCRIPTION] IMPORT_SUBSCRIPTIONS_FAILED";

export const SET_VALUE = "[SUBSCRIPTION EDIT] SET_VALUE";
export const CLEAR_VALUES = "[SUBSCRIPTION EDIT] CLEAR_VALUES";

export { create, edit, detail };

export function setValue(payload: any) {
	return { type: SET_VALUE, payload };
}

export function clearValues() {
	return { type: CLEAR_VALUES };
}

export function importSubscriptions(
	data?: any[],
	callback?: Callback<ISubscription[]>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: IMPORT_SUBSCRIPTIONS });

		try {
			const { login } = getState();

			const response = await api.sendPost("/Subscription/Import", data, {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: IMPORT_SUBSCRIPTIONS_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: IMPORT_SUBSCRIPTIONS_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: IMPORT_SUBSCRIPTIONS_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function getSubscriptions(
	skip?: number,
	take: number = 10,
	filter?: any[],
	sort?: string,
	desc?: boolean,
	toExport?: boolean,
	callback?: Callback<ISubscription[]>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_SUBSCRIPTIONS });

		try {
			const { login } = getState();

			const response = await api.sendGet(
				`/Subscription?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${
					filter || "&filters=null"
				}`,
				{
					Authorization: `Bearer ${login.token}`
				}
			);

			const result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_SUBSCRIPTIONS_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / (take || 10)),
								...result.params
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_SUBSCRIPTIONS_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_SUBSCRIPTIONS_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function getInstallmentsForOperator(
	callback?: Callback<IInstallment[]>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: GET_INSTALLMENTS });

		try {
			const { login } = getState();

			const response = await api.sendGet("/Subscription/Operator", {
				Authorization: `Bearer ${login.token}`
			});

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: GET_INSTALLMENTS_SUCCESS,
					payload: result.model
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: GET_INSTALLMENTS_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: GET_INSTALLMENTS_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}

export function generateInstallmentsBankBillet(
	models: IInstallment[],
	callback?: Callback<IBankBillet>
) {
	return async (dispatch: any, getState: any) => {
		dispatch({ type: PAY_INSTALLMENTS });

		try {
			const { login } = getState();

			const response = await api.sendPost(
				"/Subscription/Pay",
				models.map(c => c._id),
				{
					Authorization: `Bearer ${login.token}`
				}
			);

			const result = await response.json();

			if (result.isValid) {
				dispatch({
					type: PAY_INSTALLMENTS_SUCCESS
				});

				callback && callback(null, result.model);
			} else {
				const errors = getErrors(result.errors);

				dispatch({
					type: PAY_INSTALLMENTS_FAILED,
					payload: errors
				});
				callback && callback(errors);
			}
		} catch (error) {
			return dispatch({
				type: PAY_INSTALLMENTS_FAILED,
				payload: {
					error: "Connection error"
				}
			});
		}
	};
}
